import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45db1e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "bodyLogin",
  style: {"background":"url('/layout/images/pages/login/bgil1.jpg') center top / cover no-repeat fixed","transition":"background 1s ease-in-out 0s"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "limiter" }
const _hoisted_4 = { class: "container-login100" }
const _hoisted_5 = { class: "wrap-login100" }
const _hoisted_6 = { class: "login100-form-logo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-landscape" }, null, -1 /* HOISTED */))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login100-form-title p-b-34 p-t-27 mb-5" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "p-float-label wrap-input100 validate-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"color":"white","font-size":"1.5rem"},
  class: "pi pi-user",
  for: "username"
}, null, -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-float-label wrap-input100 validate-input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"color":"white","font-size":"1.5rem"},
  class: "pi pi-lock",
  for: "password"
}, null, -1 /* HOISTED */))
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = { class: "container-login100-form-btn" }
const _hoisted_17 = ["loading"]
const _hoisted_18 = { class: "text-center p-t-90 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!
  const _component_DobleFactor = _resolveComponent("DobleFactor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "bottom-right",
      style: {"z-index":"8888888888888"}
    }),
    _createElementVNode("body", _hoisted_1, [
      (!_ctx.isForgetPass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleSubmit(!_ctx.v$.$invalid)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("img", {
                        src: _ctx.getLogoUrl,
                        style: {"width":"100px"}
                      }, null, 8 /* PROPS */, _hoisted_8),
                      _createCommentVNode("Logo Base64 "),
                      _createCommentVNode("<img v-bind:src=\"'data:image/png;base64,'+ appCfg.logopng\" style=\"width: 100px\" />")
                    ]),
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        id: "username",
                        class: _normalizeClass(["input100", { 'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted }]),
                        type: "text",
                        name: "usernameInput",
                        placeholder: "Usuario",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.username) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.request.username]
                      ]),
                      _hoisted_11
                    ]),
                    _createElementVNode("span", null, [
                      ((_ctx.v$.username.$invalid && _ctx.submitted) || _ctx.v$.username.$pending.$response)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.username.required.$message), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("span", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        id: "password",
                        class: _normalizeClass(["input100", { 'p-password': true, 'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted }]),
                        type: "password",
                        name: "passwordInput",
                        placeholder: "Contraseña",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.password) = $event)),
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitLogin && _ctx.onSubmitLogin(...args)), ["enter"])),
                        "toggle-mask": ""
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelText, _ctx.request.password]
                      ]),
                      _hoisted_14
                    ]),
                    _createElementVNode("span", null, [
                      ((_ctx.v$.password.$invalid && _ctx.submitted) || _ctx.v$.password.$pending)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.password.required.$message), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "login100-form-btn",
                        id: "submitButton",
                        type: "submit",
                        loading: _ctx.showLoading,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitLogin && _ctx.onSubmitLogin(...args)))
                      }, " Acceder ", 8 /* PROPS */, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", {
                        class: "txt1",
                        href: "#",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmitForgotPassword && _ctx.onSubmitForgotPassword(...args)))
                      }, [
                        _createTextVNode(" ¿Ha olvidado su contraseña? " + _toDisplayString(_ctx.appCfg.version) + " ", 1 /* TEXT */),
                        _createCommentVNode("{{ version }}")
                      ])
                    ])
                  ])
                ])
              ])
            ], 32 /* HYDRATE_EVENTS */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isForgetPass)
        ? (_openBlock(), _createBlock(_component_ForgotPassword, {
            key: 1,
            isForgetPassChild: _ctx.isForgetPass,
            "onUpdate:isForgetPassChild": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isForgetPass) = $event))
          }, null, 8 /* PROPS */, ["isForgetPassChild"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    (_ctx.showModalAuthType)
      ? (_openBlock(), _createBlock(_component_DobleFactor, {
          key: 0,
          showModalAuthTypeChild: _ctx.showModalAuthType,
          "onUpdate:showModalAuthTypeChild": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showModalAuthType) = $event)),
          routes: _ctx.routes,
          container: _ctx.container
        }, null, 8 /* PROPS */, ["showModalAuthTypeChild", "routes", "container"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}